<template>
	<div class="page">
		<HeaderBar title="血常规"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<van-cell-group v-show="form.bq400xcg.guid">
					<checkItem v-for="(item,index) in dataList" :key="index" :config="item" @setFormData="setFormData"
						v-model="form.bq400xcg">
					</checkItem>
				</van-cell-group>
				<FormNormalUpload label="上传报告" ref="normalUpload" :infoGuid='form.bq400xcg.guid'></FormNormalUpload>
				<div class="page-bottom-box" style="margin: 16px;" v-show='!savestate'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq400xcg.guid!=''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>

<script>
	// 引入服务组件
	import componentsModel from '../../../base/components.js'
	// 引入子页面的混入对象
	import mixinModel from '../mixins/mixins.js'
	export default {
		name: "page004",
		mixins: [mixinModel],
		data() {
			return {
				modelname: 'bq400xcg',
				form: {
					bq400xcg: {
						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq400guid: "", //随访基本信息表编号
						bq400087: "", //白细胞计数
						bq4000872: "", //值
						bq4000873: "", //单位
						bq400095: "", //中性粒细胞计数
						bq4000952: "", //值
						bq4000953: "", //单位
						bq400093: "", //淋巴细胞计数
						bq4000932: "", //值
						bq4000933: "", //单位
						bq400094: "", //单核细胞计数
						bq4000942: "", //值
						bq4000943: "", //单位
						bq400099: "", //血红蛋白
						bq4000992: "", //值
						bq4000993: "", //单位
						bq400098: "", //红细胞计数
						bq4000982: "", //值
						bq4000983: "", //单位
						bq400104: "", //红细胞分布宽度
						bq4001042: "", //值
						bq4001043: "", //单位
						bq400105: "", //血小板计数
						bq4001052: "", //值
						bq4001053: "", //单位
						bq400183: "", //血小板压积
						bq4001832: "", //值
						bq4001833: "", //单位
						Bq400_guid:'',//随访基本信息表编号
						Bq400_087:'',//白细胞计数
						Bq400_087_2:'',//值
						Bq400_087_3:'',//单位
						Bq400_095:'',//中性粒细胞计数
						Bq400_095_2:'',//值
						Bq400_095_3:'',//单位
						Bq400_093:'',//淋巴细胞计数
						Bq400_093_2:'',//值
						Bq400_093_3:'',//单位
						Bq400_094:'',//单核细胞计数
						Bq400_094_2:'',//值
						Bq400_094_3:'',//单位
						Bq400_099:'',//血红蛋白
						Bq400_099_2:'',//值
						Bq400_099_3:'',//单位
						Bq400_098:'',//红细胞计数
						Bq400_098_2:'',//值
						Bq400_098_3:'',//单位
						Bq400_104:'',//红细胞分布宽度
						Bq400_104_2:'',//值
						Bq400_104_3:'',//单位
						Bq400_105:'',//血小板计数
						Bq400_105_2:'',//值
						Bq400_105_3:'',//单位
						Bq400_183:'',//血小板压积
						Bq400_183_2:'',//值
						Bq400_183_3:'',//单位
					},
					sempFiles: []
				},
				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq400xcg/Save',
				dataList: [],
				bq400: JSON.parse(sessionStorage.getItem('bq400')),
				savestate:false,
			}
		},
		components: {
			...componentsModel
		},
		methods: {
			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400xcg/Info',args, function(d) {
					let dataModel = d.Data
					if (dataModel != null) {
						that.$utils.CopyKeyInfo(dataModel, dataModel)
						that.$set(that.form, "bq400xcg", dataModel)
					}
				}, null, null, null);
			},

			//保存信息
			SaveInfo: function() {
				let that = this
				that.savestate=true
				that.$utils.CopyKeySave(that.form.bq400xcg, that.form.bq400xcg)
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			this.form.bq400xcg.bq400guid = this.bq400.guid
			this.LoadDataList()
			this.LoadInfo()
		}
	}
</script>

<style scoped>

</style>
